import {observable, action, computed, createTransformer, reaction, extendObservable} from "mobx";
import ContratacoesConcluidasService from "../../../services/ContratacoesConcluidasService";
import ProdutoService from "../../../services/ProdutoService";
import CargoService from "../../../services/CargoService";
import moment from "moment/moment";
import ContratacoesFiltroStore from "./ContratacoesFiltroStore";

export default class ContratacoesConcluidasStore extends ContratacoesFiltroStore{

    @observable contratacoesConcluidasLista;
    @observable loading;
    @observable filtros;
    @observable quantidadeTotal;

    constructor(props) {
        super(props);
        this.loading = false;
        this.contratacoesConcluidasLista = [];
        this.ContratacoesConcluidasService = new ContratacoesConcluidasService();
        this.quantidadeTotal = 0;
    }

    carregarTabela = () => {
        this.loading = true;

        const loadingPromises = Promise.all([
            this.ContratacoesConcluidasService.listarContratacoesConcluidas(_.pickBy(this.filtros, _.identity)).then(response => {
                this.contratacoesConcluidasLista = response.data.lista;
                this.quantidadeTotal = response.data.quantidadeTotal;
            }).catch(error => {
                console.log(error);
            })
        ]);
        loadingPromises.then(
            () => {
                this.loading = false;
            }
        ).catch(
            (error) => this.loading = false
        )
    }

    setLista = (value) => {
        this.contratacoesConcluidasLista = value;
    }
}